/* eslint-disable no-param-reassign */
import {
  capitalize,
} from '@/utils/stringHelpers';

import countriesData from '@/utils/countriesData';
import sourceOptions from '@/utils/sourceOptions';

import useSectionState from '@/state/useSectionState';

const knownSources = new Set(sourceOptions.map((s) => s.value));

// Display overrides for source values that aren't a simple title-case of the
// raw key (e.g. acronyms). Anything not listed here falls back to capitalize().
const sourceDisplayOverrides = {
  ai: 'AI',
};

const formatSourceLabel = (source) => sourceDisplayOverrides[source] ?? capitalize(source);

const { getCompsetData } = useSectionState();

const replaceCompset = {
  destination: 'proximity',
};

const mergeCompsetData = (obj) => {
  const { compset } = obj;

  const compsetData = getCompsetData(replaceCompset[compset] || compset);

  if (compset && !compsetData.compsetTag) {
    return null;
  }

  if (typeof obj.source === 'string') {
    // set country

    if (!knownSources.has(obj.source) && obj.source.match(/^\w{2}$/)) {
      const matchCountry = countriesData.filter((c) => c.country_code === obj.source)[0];

      if (matchCountry) {
        obj.source = matchCountry.country;
      }
    } else {
      obj.source = formatSourceLabel(obj.source);
    }
  }

  return {
    ...obj,
    ...compsetData,
  };
};

export default mergeCompsetData;
